import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './LoginPage.css';

// API 기본 URL 설정
const API_URL = process.env.REACT_APP_API_URL || '/api';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // 동시접속 제한으로 인한 세션 종료 메시지 표시
  useEffect(() => {
    const sessionMsg = sessionStorage.getItem('session_expired_message');
    if (sessionMsg) {
      setError(sessionMsg);
      sessionStorage.removeItem('session_expired_message');
    }
  }, []);

  // 이미 로그인되어 있는지 확인 - 토큰은 HttpOnly 쿠키에 있으므로
  // 백엔드에 확인 요청 보내기
  useEffect(() => {
    const checkLoginStatus = async () => {
      try {
        // 인증 상태 확인 API 호출 - 경로 수정
        const response = await axios.get(`${API_URL}/users/me/`, {
          withCredentials: true // 쿠키를 포함하여 요청
        });
        
        if (response.status === 200) {
          // 이미 로그인 상태이면 테넌트 선택 페이지로 이동
          window.location.href = '/select-tenant';
        }
      } catch (error) {
        // 로그인 상태가 아니면 아무 작업도 하지 않음
        console.log('로그인 필요');
      }
    };
    
    checkLoginStatus();
  }, []);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      // 로그인 API 호출 - /api/token/ 대신 /api/users/login/ 사용
      const loginResponse = await axios.post(`${API_URL}/users/login/`, {
        username,
        password
      }, {
        withCredentials: true // 쿠키를 받기 위해 필요
      });
      
      if (loginResponse.status === 200) {
        // 최초 로그인 비밀번호 변경 필요 여부 저장
        console.log('[LoginPage] 로그인 응답 데이터:', JSON.stringify(loginResponse.data));
        console.log('[LoginPage] must_change_password:', loginResponse.data?.must_change_password);
        if (loginResponse.data?.must_change_password) {
          sessionStorage.setItem('must_change_password', 'true');
          console.log('[LoginPage] sessionStorage에 must_change_password 저장 완료');
        }
        console.log('로그인 성공, 테넌트 정보 확인 중...');
        
        try {
          // 사용자 정보 가져오기 (슈퍼관리자 여부 확인)
          const userResponse = await axios.get(`${API_URL}/users/me/`, {
            withCredentials: true
          });
          
          const isSuper = !!userResponse.data?.is_superuser;
          
          // 테넌트 목록 가져오기
          const tenantsResponse = await axios.get(`${API_URL}/users/tenants/`, {
            withCredentials: true
          });
          
          const tenants = tenantsResponse.data.tenants || [];
          
          // 테넌트가 1개이고 슈퍼관리자가 아닌 경우 자동 선택
          if (tenants.length === 1 && !isSuper) {
            console.log('테넌트가 1개만 존재, 자동 선택:', tenants[0].tenant_name);
            
            // 테넌트 자동 선택
            const selectResponse = await axios.post(
              `${API_URL}/users/select-tenant/`,
              { tenant_name: tenants[0].tenant_name },
              { 
                withCredentials: true,
                headers: {
                  'Content-Type': 'application/json'
                }
              }
            );
            
            if (selectResponse.status === 200) {
              // 세션 스토리지에 저장
              sessionStorage.setItem('current_tenant', tenants[0].tenant_name);
              
              // 메인 화면으로 바로 이동
              console.log('메인 화면으로 이동');
              window.location.href = '/';
              return;
            }
          }
          
          // 그 외의 경우 테넌트 선택 페이지로 이동
          console.log('테넌트 선택 페이지로 이동');
          window.location.href = '/select-tenant';
          
        } catch (tenantError) {
          console.error('테넌트 정보 조회 오류:', tenantError);
          // 오류 발생 시 기본적으로 테넌트 선택 페이지로 이동
          window.location.href = '/select-tenant';
        }
      } else {
        setError('로그인에 실패했습니다.');
      }
    } catch (error) {
      console.error('로그인 오류:', error);
      setError(
        error.response?.data?.detail || 
        '로그인에 실패했습니다. 사용자 이름과 비밀번호를 확인해주세요.'
      );
      setLoading(false);
    }
  };
  
  return (
    <div className="login-container">
      <div className="login-box">
        <h1 className="login-title">지능형 통합 안전 시스템 v1.0.0</h1>
        <h2 className="login-subtitle">로그인</h2>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">사용자 이름</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="login-input"
              disabled={loading}
              autoComplete="username"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">비밀번호</label>
            <input
              type="password"
              id="password"
              value={password}
              maxLength={20}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="login-input"
              disabled={loading}
              autoComplete="current-password"
            />
            <div style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>
              9~20자, 영대문자·영소문자·숫자·특수문자 중 3종류 이상 포함
            </div>
          </div>
          
          <button 
            type="submit" 
            className="login-button" 
            disabled={loading}
          >
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage; 